import * as ko from 'knockout';
import * as $ from 'jquery';
import * as moment from 'moment';
import {PikadayService} from "../services/pikadayService";
import {DatetimeService} from "../services/datetimeService";

declare var DobryKantor: any;
declare var Chart: any;
declare var BACKENDPATH: any;

export class CurrencyChartComponent {
    currency: ko.Observable<string>;
    startDate: ko.Observable<string>;
    endDate: ko.Observable<string>;
    datePeriod: ko.Observable<string>;
    chart: any = null;

    private datetimeService: DatetimeService;

    constructor(params) {
        this.datetimeService = new DatetimeService();

        this.currency = ko.observable(params.currency);

        this.startDate = ko.observable("");
        this.endDate = ko.observable("");
        this.datePeriod = ko.observable("6");
        this.datePeriod.subscribe((newValue) => this.datePeriodChanged(newValue));
        this.datePeriodChanged("6");

        let pikadayService = new PikadayService();

        pikadayService.init($('#currency-chart-start-date')[0] as HTMLElement);
        pikadayService.init($('#currency-chart-end-date')[0] as HTMLElement);

        this.showChart();
    }

    datePeriodChanged(newValue: string) {
        let today = moment().startOf('day').toDate();
        let ago = moment();
        switch (newValue) {
            case "1":
                break;
            case "2":
                ago = ago.subtract(7, 'day');
                break;
            case "3":
                ago = ago.subtract(1, 'month');
                break;
            case "4":
                ago = ago.subtract(3, 'month');
                break;
            case "5":
                ago = ago.subtract(6, 'month');
                break;
            case "6":
                ago = ago.subtract(1, 'year');
                break;
            case "7":
                ago = ago.subtract(2, 'year');
                break;
            case "8":
                ago = ago.subtract(3, 'year');
                break;
        }

        this.startDate(this.datetimeService.format(ago.toDate()));
        this.endDate(this.datetimeService.format(today));
    }

    showChart() {
        $.get(BACKENDPATH + '/api/currency/currency-rates', {
            currency: this.currency(),
            startDate: this.startDate(),
            endDate: this.endDate(),
            datePeriod: this.datePeriod()
        }).then(result => {
            if (this.chart) {
                this.chart.destroy();
            }

            var chart = document.getElementById("myChart") as any;
            var ctx = chart.getContext('2d');

            this.chart = new Chart(ctx, {
                options: {
                    legend: {
                        display: false
                    },
                    chartArea: {
                        backgroundColor: 'white'
                    }
                },
                type: 'line',
                data: {
                    labels: result.map(cr => cr.DateTime),
                    datasets: [{
                        lineTension: 0,
                        radius: 0,
                        pointHitRadius: 10,
                        label: 'Kurs',
                        borderColor: 'black',
                        borderWidth: 2,
                        backgroundColor: 'transparent',
                        data: result.map(cr => cr.Rate)
                    }]
                }
            });
        });
    }

    dispose() {
        this.chart.destroy();
    }
}
